(function () {
  if (window.__IAL_CARD_MEDIA_SLIDER_READY__) return;
  window.__IAL_CARD_MEDIA_SLIDER_READY__ = true;

  function getParts(slider) {
    return {
      track: slider && slider.querySelector('[data-ial-card-slider-track]'),
      prev: slider && slider.querySelector('[data-ial-card-slider-prev]'),
      next: slider && slider.querySelector('[data-ial-card-slider-next]'),
      dots: slider ? Array.from(slider.querySelectorAll('[data-ial-card-slider-dot]')) : []
    };
  }

  function currentIndex(track) {
    return Math.round(track.scrollLeft / (track.clientWidth || 1));
  }

  function scrollToIndex(slider, index) {
    const parts = getParts(slider);
    if (!parts.track) return;
    const max = Math.max(0, parts.track.children.length - 1);
    const nextIndex = Math.min(Math.max(index, 0), max);
    const nextLeft = nextIndex * parts.track.clientWidth;
    parts.track.scrollLeft = nextLeft;
    if (Math.abs(parts.track.scrollLeft - nextLeft) > 2 && parts.track.scrollTo) {
      parts.track.scrollTo({ left: nextLeft, behavior: 'smooth' });
    }
    window.setTimeout(function () { syncSlider(slider); }, 220);
  }

  function syncSlider(slider) {
    const parts = getParts(slider);
    if (!parts.track) return;
    const index = currentIndex(parts.track);
    parts.dots.forEach(function (dot, dotIndex) {
      dot.classList.toggle('is-active', dotIndex === index);
      dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
    });
    if (parts.prev) parts.prev.disabled = index <= 0;
    if (parts.next) parts.next.disabled = index >= parts.track.children.length - 1;
  }

  function initSliders(root) {
    (root || document).querySelectorAll('ial-card-media-slider').forEach(function (slider) {
      if (slider.dataset.ialSliderBound === 'true') return;
      slider.dataset.ialSliderBound = 'true';
      const parts = getParts(slider);
      if (!parts.track) return;
      parts.track.addEventListener('scroll', function () { syncSlider(slider); }, { passive: true });
      parts.track.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        slider.dataset.ialPointerStartX = String(event.clientX);
        slider.dataset.ialPointerStartY = String(event.clientY);
      }, { passive: true });
      parts.track.addEventListener('pointerup', function (event) {
        const startX = Number(slider.dataset.ialPointerStartX || event.clientX);
        const startY = Number(slider.dataset.ialPointerStartY || event.clientY);
        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;
        slider.dataset.ialPointerStartX = '';
        slider.dataset.ialPointerStartY = '';
        if (Math.abs(deltaX) < 35 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        scrollToIndex(slider, currentIndex(parts.track) + (deltaX < 0 ? 1 : -1));
      }, { passive: true });
      syncSlider(slider);
    });
  }

  function initProductGalleryCounters(root) {
    (root || document).querySelectorAll('media-gallery, .product__media-gallery').forEach(function (gallery) {
      if (gallery.dataset.ialProductGalleryBound === 'true') return;
      const mediaList = gallery.querySelector('.product__media-list, slider-component ul');
      const mediaItems = mediaList ? Array.from(mediaList.querySelectorAll('.product__media-item')) : [];
      if (!mediaList || mediaItems.length <= 1) return;
      gallery.dataset.ialProductGalleryBound = 'true';
      const counter = document.createElement('div');
      counter.className = 'ial-product-gallery-counter';
      gallery.appendChild(counter);

      function updateCounter() {
        const items = mediaItems;
        const width = mediaList.clientWidth || 1;
        let index = Math.round(mediaList.scrollLeft / width);
        const activeIndex = items.findIndex(function (item) {
          return item.classList.contains('is-active') || item.getAttribute('aria-current') === 'true';
        });
        if (activeIndex >= 0) index = activeIndex;
        index = Math.min(Math.max(index, 0), Math.max(items.length - 1, 0));
        counter.textContent = String(index + 1) + '/' + String(items.length);
      }

      gallery.addEventListener('click', function () {
        window.setTimeout(updateCounter, 250);
      }, true);
      mediaList.addEventListener('scroll', updateCounter, { passive: true });
      updateCounter();
    });
  }

  window.ialCardSlideTo = function (control, index) {
    const slider = control && control.closest('ial-card-media-slider');
    if (slider) scrollToIndex(slider, index);
  };

  window.ialCardSlide = function (control, direction) {
    const slider = control && control.closest('ial-card-media-slider');
    const parts = getParts(slider);
    if (!slider || !parts.track) return;
    scrollToIndex(slider, currentIndex(parts.track) + direction);
  };

  document.addEventListener('click', function (event) {
    const nextButton = event.target.closest('[data-ial-card-slider-next]');
    const prevButton = event.target.closest('[data-ial-card-slider-prev]');
    const dotButton = event.target.closest('[data-ial-card-slider-dot]');
    const control = nextButton || prevButton || dotButton;
    if (!control) return;
    const slider = control.closest('ial-card-media-slider');
    const parts = getParts(slider);
    if (!slider || !parts.track) return;
    event.preventDefault();
    event.stopPropagation();
    if (dotButton) {
      scrollToIndex(slider, parts.dots.indexOf(dotButton));
      return;
    }
    scrollToIndex(slider, currentIndex(parts.track) + (nextButton ? 1 : -1));
  }, true);

  document.addEventListener('DOMContentLoaded', function () { initSliders(document); });
  document.addEventListener('DOMContentLoaded', function () { initProductGalleryCounters(document); });
  document.addEventListener('shopify:section:load', function (event) {
    initSliders(event.target);
    initProductGalleryCounters(event.target);
  });
  initSliders(document);
  initProductGalleryCounters(document);
})();
